import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for offline PWA shell. Dev mode skips it so
// hot-reload isn't competing with cached chunks. After registration we
// proactively check for an updated SW on every navigation, and reload
// once exactly when the new SW takes control — so users on a stale
// build pick up new lazy-chunk hashes (e.g. /clinical-library, /ce-hub,
// /reasoning-pilot, /household-sim) immediately instead of seeing a
// silently-broken page.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Force an update check on every full page load.
        try { reg.update(); } catch { /* noop */ }
        // When a new worker takes over, reload exactly once so the page
        // re-fetches the latest hashed JS/CSS.
        let reloaded = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (reloaded) return;
          reloaded = true;
          window.location.reload();
        });
        // When the next SW finishes installing, tell it to take over now.
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              sw.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch(() => { /* registration failures are non-fatal */ });
    // Keep the offline study pack synced: trigger the (resumable)
    // background download on every load and whenever we come back online.
    const syncPack = () =>
      navigator.serviceWorker.ready
        .then((reg) => reg.active && reg.active.postMessage("SYNC_PACK"))
        .catch(() => {});
    setTimeout(syncPack, 4000);
    window.addEventListener("online", syncPack);
  });
}
